'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createNonce = createNonce;
function createNonce() {
  var nonce = '';
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  for (var i = 0; i < 40; i += 1) {
    nonce += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return nonce;
}